import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFacetsStore = defineStore('facets', () => {

    const facets = ref();

    function updateFacets(newFacets) {

        if (newFacets.data) {

            facets.value = newFacets.data.facets;

            return;

        }

        facets.value = newFacets;

    }

    function uncheckAllFacets() {

        facets.value.forEach((facet) => {

            facet.facetOptions.forEach((option) => {

                option.checked = false;

            })

        });

    }

    return {
        facets,
        updateFacets,
        uncheckAllFacets,
    }

});
